export enum ProgrammingTabs {
  Profile = 'profile',
  Building = 'building',
  Summary = 'summary',
  Downloads = 'downloads',
}

export const isProdEnv = process.env.ENV === 'production';
